import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const msalConfig: Configuration = {
	auth: {
		clientId: process.env.REACT_APP_AZURE_AID ?? "",
		authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TID}`,
	},
	cache: {
		cacheLocation: "localStorage",
	},
};

const AuthInstance: {
	pca: PublicClientApplication | null;
	getInstance: () => PublicClientApplication;
} = {
	pca: null,
	getInstance: () => {
		return AuthInstance.pca ?? new PublicClientApplication(msalConfig);
	},
};

export default AuthInstance.getInstance();